import { render, staticRenderFns } from "./priSettingsGoogleCustomSearchEngine.vue?vue&type=template&id=1671aa71"
import script from "./priSettingsGoogleCustomSearchEngine.vue?vue&type=script&lang=js"
export * from "./priSettingsGoogleCustomSearchEngine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports